let env = {};

env.baseURL = 'https://api.innovare.innovsign.com.br/api/v1/';
env.normalURL = 'https://api.innovare.innovsign.com.br/';

export default env



// WEBPACK FOOTER //
// ./src/config/env.js